module.exports = __webpack_public_path__ + "img/drink.68c4fccf.svg";